import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-146" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-147" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-148" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-149" data-mp="tyv5tcf1sfy9">🏆 </span>Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-150" data-mp="u0xsbmgzrqy8">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-151" data-mp="p24ratiw5sey">
            ACCOUNTING READY™ Full Curriculum Pack
          </span>

          <dl data-id="element-152" data-mp="2fbeoyg13r3a6">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-153" data-mp="2fe0w4ek2zgrv">
                <dt className="text-ink/80" data-id="element-154" data-mp="pjp8dsxh4km8">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-155" data-mp="uiselgp6wwvs">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-156" data-mp="zi5305vpmc0h">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-157" data-mp="13k9tivqv2siw">Total Value:</dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-158" data-mp="6u98n7tm4w6v">$182</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-159" data-mp="bs10y2y66kbl">
            Only today
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-160" data-mp="fsb4l8yhoyna">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-161" data-mp="kn8nd7lkmmdd">
              🏆
            </span>
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-162" data-mp="3k6jak93re7xb">
              $27{' '}
              <span className="align-middle text-2xl font-bold tracking-tight" data-id="element-163" data-mp="vfqxu4aubgt9">USD</span>
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-164" data-mp="qh5x83roev4a">
            <span aria-hidden="true" data-id="element-165" data-mp="15620lnisfjyk">💳 </span>One-time payment. Lifetime access. No subscriptions.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-166" data-mp="1067b9oenv2fm" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-167" data-mp="108k08liu6d26">
            Instant Download · Secure Payment · Lifetime Access · 7-Day Guarantee
          </p>
        </div>
      </div>
    </section>;
}